// eslint-disable-next-line import/prefer-default-export
export const muiFormHelperTextComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      columnGap: theme.spacing('SMALL'),
      display: 'flex',
      margin: `${theme.spacing('SMALL')} ${theme.spacing('NONE')} ${theme.spacing('NONE')}`,

      [`&.Mui-error::before`]: {
        content: `url(/images/design-assets/form_field_error.svg)`,
      },
    }),
  },
};
